// 接口URL
// export const bizURL='http://biz.winwu.cn:8080/winwu-biz-web/'   //企业
// export const cmsURL='http://cms.winwu.cn:8080/winwu-cms-web/'   //新闻
// export const courseURL = 'http://course.winwu.cn:8080/winwu-course-web/' //课程
//某个企业的门户域名，在不同域名用同套代码调试时修改
export const pUrl = window.location.href;
export const eUrl = window.location.href;
// export const pUrl = "http://lili.e.eceping.net";
// export const eUrl = "http://lili.e.eceping.net";
// export const pUrl = "http://ychc.e.eceping.net";
// export const eUrl = "http://ychc.e.eceping.net";


// export const pUrl = 'https://cspx.e.eceping.net';
// export const eUrl = 'https://cspx.e.eceping.net';


// let nowPath = window.location.href
// let nowPath = "https://djn.e.eceping.net"
// let requestPath = nowPath.split(".eceping.net.")[0].slice(8) //江西
// if (nowPath.slice(0, 5) === "https") {
// var bizURLif = `https://${requestPath}.e.eceping.net/winwu-biz-web/`
// var cmsURLif = `https://${requestPath}.e.eceping.net/winwu-cms-web/`
// var courseURLif = `https://${requestPath}.e.eceping.net/winwu-course-web/`
// var localURLif = `https://${requestPath}.e.eceping.net/index.html`
// var examURLif = `https://${requestPath}.e.eceping.net/winwu-exam-web/`
// var statURLif = `https://${requestPath}.e.eceping.net/winwu-stat-web/`
// var questionbankUrlif = `https://${requestPath}.e.eceping.net/winwu-questionbank-web/`
// var payUrlif = `https://${requestPath}.e.eceping.net/winwu-pay-web/`


//测试环境
// var bizURLif = "http://101.132.242.99:8080/winwu-biz-web/"
// var cmsURLif = 'http://101.132.242.99:8080/winwu-cms-web/'
// var courseURLif = 'http://101.132.242.99:8080/winwu-course-web/'
// var localURLif = 'http://101.132.242.99:8080/index.html'
// var examURLif = 'http://101.132.242.99:8080/winwu-exam-web/'
// var statURLif = 'http://101.132.242.99:8080/winwu-stat-web/'
// var questionbankUrlif = 'http://101.132.242.99:8080/winwu-questionbank-web/'
// var payUrlif = 'http://101.132.242.99:8080/winwu-pay-web/'


// var bizURLif = "http://192.168.1.30:8082/winwu-biz-web/"
// var cmsURLif = 'http://192.168.1.30:8082/winwu-cms-web/'
// var courseURLif = 'http://192.168.1.30:8082/winwu-course-web/'
// var localURLif = 'http://192.168.1.30:8082/index.html'
// var examURLif = 'http://192.168.1.30:8082/winwu-exam-web/'
// var statURLif = 'http://192.168.1.30:8082/winwu-stat-web/'
// var questionbankUrlif = 'http://192.168.1.30:8082/winwu-questionbank-web/'
// var payUrlif = 'http://192.168.1.30:8082/winwu-pay-web/'

var bizURLif = "/eceping-biz/"
var cmsURLif = '/eceping-cms/'
var courseURLif = '/eceping-course/'
var localURLif = '/index.html'
var examURLif = '/eceping-exam/'
var statURLif = '/eceping-stat/'
var questionbankUrlif = '/eceping-questionbank/'
var payUrlif = '/eceping-pay/'


// // }
//湖北环境
// var bizURLif = "http://101.132.242.99:8080/winwu-biz-web/"
// var cmsURLif = 'http://101.132.242.99:8080/winwu-cms-web/'
// var courseURLif = 'http://101.132.242.99:8080/winwu-course-web/'
// var localURLif = 'http://101.132.242.99:8080/index.html'
// var examURLif = 'http://101.132.242.99:8080/winwu-exam-web/'
// var statURLif = 'http://101.132.242.99:8080/winwu-stat-web/'
// var questionbankUrlif = 'http://101.132.242.99:8080/winwu-questionbank-web/'
// var payUrlif = 'http://101.132.242.99:8080/winwu-pay-web/'


// var bizURLif = "https://hshc.e.eceping.net/winwu-biz-web/"
// var cmsURLif = 'https://hshc.e.eceping.net/winwu-cms-web/'
// var courseURLif = 'https://hshc.e.eceping.net/winwu-course-web/'
// var localURLif = 'https://hshc.e.eceping.net/index.html'
// var examURLif = 'https://hshc.e.eceping.net/winwu-exam-web/'
// var statURLif = 'https://hshc.e.eceping.net/winwu-stat-web/'
// var questionbankUrlif = 'https://hshc.e.eceping.net/winwu-questionbank-web/'
// var payUrlif = 'https://hshc.e.eceping.net/winwu-pay-web/'

export const bizURL = bizURLif; //企业
export const cmsURL = cmsURLif; //新闻
export const courseURL = courseURLif; //课程
export const localURL = localURLif; //课程
export const examURL = examURLif; //考试
export const statURL = statURLif; //考试
export const questionbankUrl = questionbankUrlif;
export const payUrl = payUrlif;



// WEBPACK FOOTER //
// ./src/api/baseURL.js